export async function requestJson(url, options = {}) {
  const response = await fetch(url, options);
  const contentType = response.headers.get('content-type') || '';
  const rawBody = await response.text();
  const bodyTrimmed = rawBody.trim();

  let data = {};
  const looksLikeJson = bodyTrimmed.startsWith('{') || bodyTrimmed.startsWith('[');
  const htmlLike =
    bodyTrimmed.startsWith('<!DOCTYPE') || bodyTrimmed.startsWith('<html');

  if (response.status === 204 || !bodyTrimmed) {
    data = {};
  } else if (contentType.includes('application/json') || looksLikeJson) {
    try {
      data = JSON.parse(rawBody);
    } catch {
      throw new Error('Received invalid JSON from API response.');
    }
  } else if (htmlLike) {
    throw new Error(
      'API returned HTML instead of JSON. If you are running locally, start the app with "npm run dev:vercel" so the frontend and serverless routes share the same origin.'
    );
  } else {
    const snippet = bodyTrimmed.slice(0, 200);
    throw new Error(
      `Unexpected response type: ${contentType || 'unknown'} (status ${response.status})${
        snippet ? ` - ${snippet}` : ''
      }`
    );
  }

  if (!response.ok) {
    const error = new Error(
      data.error || data.details || `Request failed (status ${response.status})`
    );
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
